import { CopyOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { FC, MouseEvent } from "react";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText } from "@/components/Typography/Styled";

import { StyledCHCopyButton, StyledCHTypography } from "./Styled";

interface ICheckoutHeader {
    invoiceId: string;
    copyCheckoutInfoToClipboard: () => void;
    fop: string;
    address: string;
    orderDate: string;
    orderType: string;
    totalSum: string;
}

export const CheckoutHeader: FC<ICheckoutHeader> = ({
    invoiceId,
    copyCheckoutInfoToClipboard,
    fop,
    address,
    orderDate,
    orderType,
    totalSum,
}) => {
    const formattedDate = dayjs(orderDate).isValid()
        ? dayjs(orderDate).format("HH:mm:ss")
        : "-";

    const handleCopyClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        copyCheckoutInfoToClipboard();
    };

    return (
        <FlexContainer
            gap="8px"
            alignItems="flex-start"
            justifyContent="flex-start"
            width="100%"
            flexDirection="column"
        >
            <FlexContainer justifyContent="space-between" width="100%">
                <PrimaryText fontSize={16}>{invoiceId}</PrimaryText>
                <StyledCHCopyButton
                    shape="circle"
                    icon={<CopyOutlined />}
                    onClick={handleCopyClick}
                />
            </FlexContainer>

            <StyledCHTypography>&quot;{fop || "-"}&quot;</StyledCHTypography>

            <StyledCHTypography>{address || "-"}</StyledCHTypography>

            <FlexContainer
                alignItems="center"
                justifyContent="space-between"
                width="100%"
            >
                <StyledCHTypography>{formattedDate}</StyledCHTypography>

                {orderType !== "r" && (
                    <StyledCHTypography isAmount>
                        {totalSum} ₴
                    </StyledCHTypography>
                )}
            </FlexContainer>
        </FlexContainer>
    );
};
